import { schema as schemas } from 'normalizr'

import { CallApi } from '@signavio/kraken'

export const collection = 'externalActivityInfos'
export const schema = new schemas.Array(new schemas.Entity(collection))

type FetchParamsType = {
  externalActivityId: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { externalActivityId }: FetchParamsType) =>
    callApi(
      `${apiBase}/activities/${externalActivityId}/configurations`,
      schema
    )
